import React from "react";

import estilo from "./styles/Separador.module.css";

function Separador({ titulo }) {
  return (
    <div className={estilo.separador}>
      <h2>{titulo}</h2>
    </div>
  );
}

export default Separador;
